import { Events, LoadingController, Platform } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from '../../environments/environment';
import { catchError, tap } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

import { Storage } from '@ionic/storage';
//import { Network } from '@ionic-native/network';
import { LogProvider } from '../log/log';
import { OneSignal } from '@ionic-native/onesignal';


/*
  Generated class for the AuthProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
const TOKEN_KEY = environment.access_token;
const FORGOT_PASSWORD_KEY = environment.forgot_key;

@Injectable()
export class AuthProvider {
    url = environment;
    user = null;
    authenticationState = new BehaviorSubject(false);
    loader: any;
    token: string = '';
    deviceID = '';
    constructor(
        private http: HttpClient,
        private helper: JwtHelperService,
        private storage: Storage,
        private plt: Platform,
        public loadingController: LoadingController,
        //public network: Network,
        private oneSignal: OneSignal,
        public events: Events,
        public logger: LogProvider
    ) {
        this.plt.ready().then(() => {
            this.logger.log('Platform ready', '');


        });
        this.storage.get('DEVICE_ID').then(device_id => {
            this.deviceID = device_id;
            console.log('Device id', device_id);
        })
        // this.events.subscribe('device_id', (device_id) => {
        //     this.deviceID = device_id;
        //     console.log('Device id', device_id);
        // });
    }

    checkToken() {
        return this.storage.get(TOKEN_KEY).then(token => {
            let result: string = '';
            if (token) {
                this.token = token;
                let decoded = this.helper.decodeToken(token);
                let isExpired = this.helper.isTokenExpired(token);
                result = 'invalid';
                if (!isExpired) {
                    this.user = decoded.info;
                    this.authenticationState.next(true);
                    this.logger.log('Token valid', decoded.info);
                    result = 'valid';
                }

            } else {
                result = 'not_found';
            }
            return result;
        });

    }

    getResetToken() {
        return this.storage.get(FORGOT_PASSWORD_KEY).then(token => {
            return token;
        });
    }

    register(credentials) {
        credentials['device'] = this.deviceID;
        this._setLoader();
        return this.http.post(this.url.register, credentials).pipe(
            tap(res => {
                this._closeLoader();
                if (res['err_code'] === '') {
                    this.storage.set(TOKEN_KEY, res['data']);
                    this.user = this.helper.decodeToken(res['data'].toString()).info;
                    this.authenticationState.next(true);
                    // this.sendOnesignalData();
                }
                return res;
            }),
            catchError(e => {
                this.showAlert(e);
                throw e;
            })
        );
    }

    forgotPassword(credentials) {
        this._setLoader();
        return this.http.post(this.url.forgotPassword, credentials).pipe(
            tap(res => {
                this._closeLoader();
                if (res['err_code'] === '') {
                    this.storage.set(FORGOT_PASSWORD_KEY, res['data']);
                }
                return res;
            }),
            catchError(e => {
                this.showAlert(e);
                throw e;
            })
        );
    }

    resetPassword(credentials) {
        this._setLoader();
        return this.http.post(this.url.resetPassword, credentials).pipe(
            tap(res => {
                this._closeLoader();
                if (res['err_code'] === '') {
                    this.storage.remove(FORGOT_PASSWORD_KEY);
                }
                return res;
            }),
            catchError(e => {
                this.showAlert(e);
                throw e;
            })
        );
    }

    login(credentials) {
        credentials['device'] = this.deviceID;
        this._setLoader();
        return this.http.post(this.url.login, credentials)
            .pipe(
                tap(res => {
                    this._closeLoader();
                    if (res['err_code'] === '') {
                        this.setUserInfo(res['data']);
                        // this.sendOnesignalData();
                    }
                    return res;
                }),
                catchError(e => {
                    this.showAlert(e);
                    throw e;
                })
            );
    }
    setUserInfo(token: string) {
        this.storage.set(TOKEN_KEY, token);
        this.user = this.helper.decodeToken(token).info;
        this.authenticationState.next(true);
        this.events.publish('user:login', this.user, Date.now());
    }
    logout() {
        this.user = null;
        this.storage.remove(TOKEN_KEY).then(() => {
            this.authenticationState.next(false);
            this.events.publish('user:logout', Date.now());
        });
        this.events.publish('user:logout', Date.now());
    }

    getSpecialData() {
        return this.http.get(`${this.url}/api/special`).pipe(
            catchError(e => {
                let status = e.status;
                if (status === 401) {
                    this.showAlert('You are not authorized for this!');
                    this.logout();
                }
                throw new Error(e);
            })
        )
    }

    isAuthenticated() {
        return this.authenticationState.value;
    }

    showAlert(msg) {
        this.logger.log('Log message:', msg);
    }

    changePassword(credentials) {
        this._setLoader();
        return this.http.post(this.url.changePassword, credentials)
            .pipe(
                tap(res => {
                    this._closeLoader();
                    return res;
                }),
                catchError(e => {
                    this.showAlert(e);
                    throw e;
                })
            );
    }

    getUserInfo() {
        return this.user;
    }

    private _setLoader() {
        this.loader = this.loadingController.create({
            content: ""
        });
        this.loader.present();

    }

    private _closeLoader() {
        this.loader.dismiss();
    }

    renewToken() {
        return this.http.post(this.url.renewToken, { token: this.token }).pipe(
            tap(res => {
                if (res['err_code'] === '') {
                    this.setUserInfo(res['data']);
                } else {
                    this.storage.remove(TOKEN_KEY);
                }
                return res;
            }),
            catchError(e => {
                this.showAlert(e);
                throw e;
            })
        );
    }

    sendOnesignalData() {
        this.oneSignal.sendTags({
            user_id: this.user.id,
            user_type: this.user.role
        })
    }


}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts